import cx from "classnames";
import React from "react";

import { Dot } from "@/mk2/components/Dot";

import styles from "./LineMenu.mscss";

interface OwnProps {
    className?: string;
    dotClassName?: string;
    hideLineOnMobile?: boolean;
}

type Props = OwnProps;

export const LineMenu: React.FunctionComponent<Props> = React.memo(
    ({ className, children, dotClassName, hideLineOnMobile = true }) => (
        <div className={cx(styles.LineMenu, className)}>
            <div
                className={cx(
                    styles.LineMenu__line,
                    hideLineOnMobile && styles["LineMenu__line--hideOnMobile"],
                )}
            />
            <div className={styles.LineMenu__children}>
                {React.Children.map(children, (child, index) => (
                    <>
                        {index !== 0 && child && (
                            <Dot className={cx(styles.LineMenu__dot, dotClassName)} />
                        )}
                        {child}
                    </>
                ))}
            </div>
            <div
                className={cx(
                    styles.LineMenu__line,
                    hideLineOnMobile && styles["LineMenu__line--hideOnMobile"],
                )}
            />
        </div>
    ),
);

LineMenu.displayName = "LineMenu";
